<script setup lang="ts">
import { dynamicImportFailure } from '@/router/router'

function dismissDynamicImportFailureModal() {
  dynamicImportFailure.value = undefined
}

function reloadForLatestVersion() {
  window.location.reload()
}
</script>

<template>
  <a-modal
    :open="!!dynamicImportFailure"
    :width="700"
    :mask-closable="false"
    @cancel="dismissDynamicImportFailureModal"
  >
    <div class="flex flex-col items-center py-2 text-center">
      <h2 class="mb-2">Whoops!</h2>
      <p class="w-120">
        We couldn’t load the requested page because we've deployed some updates to the Ruminati
        Platform which you don't have yet.
      </p>
      <img src="/images/404.gif" alt="Refresh required" class="h-40 w-72 object-contain" />

      <p class="text-rumi-grey-650 mb-4 w-100 text-sm">
        If you have any unsaved changes, you'll need to close this dialog box, copy your work, and
        then reload/refresh.
      </p>
    </div>

    <template #footer>
      <div class="flex w-full justify-center gap-2">
        <a-button @click="dismissDynamicImportFailureModal"> Close for now </a-button>
        <a-button type="primary" @click="reloadForLatestVersion"> Reload now </a-button>
      </div>
    </template>
  </a-modal>
</template>
